<div  class="address-chat" style="
    background-color: white;
    width: 400px;
    height: 500px;
    overflow-y: auto;
    padding: 15px;
  ">
  <div class="input-group justify-content-between">
    <h2 class="m-0 text-strong" style="font-weight:bold;">MySembra Address Book</h2>
    <div class="input-group-append">
      <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
        <mat-icon>menu</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="gotoConversation()">
          <span>{{ "SEARCH_USER.MESSAGES" | translate }}</span>
        </button>
        <button mat-menu-item (click)="gotoNewMessage()">
          <span>{{ "SEARCH_USER.NEW_MSG" | translate }}</span>
        </button>
        <button mat-menu-item (click)="close()">
          <span>{{ "SEARCH_USER.CLOSE" | translate }}</span>
        </button>
      </mat-menu>
    </div>
  </div>
  <div class="input-group justify-content-between">
    <div class="search-input d-flex align-items-center col-11">
      <mat-form-field style="width: 100%;">
        <input matInput type="text" class="form-control" [(ngModel)]="searchValue" #inputSearch
          [placeholder]="'CHAT.SEARCH' | translate" />
        <button matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div class="col-1 text-center mt-3">
      <mat-icon (click)="tooltip.toggle()">info</mat-icon>
      <span #tooltip="matTooltip" matTooltipTouchGestures="off"
        matTooltip="Search by User Name, IVRID, Role, Agency and/or Branch" matTooltipPosition="above"
        matTooltipShowDelay="0">
      </span>
    </div>
  </div>

  <mat-spinner *ngIf="showLoader"></mat-spinner>
  <h2 *ngIf="filteredUserList.length === 0 && !this.showLoader">
    {{ "SEARCH_USER.NO_DATA" | translate }}
  </h2>
  <ul class="list-group chat-list">
    <ng-container *ngFor="let data of filteredUserList">
      <li class="list-group-item" (click)="gotoChat(data)">
        <div>
          <p>
            <span>
              <strong>{{ data.user.name }} </strong>
            </span>
            <span style="float:right; font-size: 11px;">
              {{ data.user.IVRID ? "IVRID: " + getIVRID(data.user.IVRID) : "" }}
            </span>
          </p>
          <p>
            <span>
              {{ getRoleName(data.Role)}},
              {{ data.user.agencycode ? data.user.agencycode.toUpperCase() : "(No Agency Code)"}}
              {{ data.user.Branch ? " - " + data.user.Branch : "" }}
            </span>
            <span style="float:right; font-size: 11px;" *ngIf="data.user.foundTags">
             Tags: <mark>{{data.user.foundTags}}</mark>
            </span>
            <!-- {{ data.user.Branch ? " - " + data.user.Branch : "(Branch Missing)" }} -->
          </p>
          <!-- <p>Branch</p> -->
        </div>
        <!-- <div>{{ data.user.createTime | date }}</div> -->
        <div style="color: red" *ngIf="checkYou(data.user.email)">
          {{ "SEARCH_USER.YOU" | translate }}
        </div>
      </li>
    </ng-container>
  </ul>
</div>